/**
 * フォーム部品（input / select / textarea）の共通クラス（2026-09-09）。
 * `@prance/ui`にはButton/Dialog/DataGrid/Badge等のプリミティブはあるが素のフォーム部品は
 * 無く、画面ごとに`rounded`/`rounded-lg`・`px-2 py-1`/`px-3 py-2`・フォーカスリング有無が
 * ばらついていた（同一画面内でも混在）。ここに集約して見た目と操作感を揃える。
 *
 * - `*_MD`: 設定フォーム・ダイアログなど単独で置く入力欄（`px-3 py-2`）
 * - `*_SM`: テーブルのセル内やインラインの操作列など密度の高い場所（`px-2 py-1`）
 * 幅（`w-full`等）・余白（`mb-3`等）は呼び出し側でテンプレートリテラルにより付け足す。
 */

const FIELD_BASE =
  "rounded-lg border border-disabled bg-surface text-body outline-none focus-visible:ring-2 focus-visible:ring-fg/15 disabled:text-muted";

export const INPUT_CLASS_MD = `${FIELD_BASE} px-3 py-2`;
export const INPUT_CLASS_SM = `${FIELD_BASE} px-2 py-1`;

export const SELECT_CLASS_MD = `hoverable cursor-pointer ${FIELD_BASE} px-3 py-2`;
export const SELECT_CLASS_SM = `hoverable cursor-pointer ${FIELD_BASE} px-2 py-1`;

export const TEXTAREA_CLASS_MD = `${FIELD_BASE} px-3 py-2`;
export const TEXTAREA_CLASS_SM = `${FIELD_BASE} px-2 py-1`;

/** ラベル（`<label>`）の共通クラス。 */
export const FIELD_LABEL_CLASS = "mb-1 block text-label text-muted";
